var _style, _path, _line, _line2, _line3, _line4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconDelete = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon-delete",
    x: "0px",
    y: "0px",
    viewBox: "0 0 27 30",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n.icon-delete .st0{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.08,4.69h-1.1h-3.14v-1.7c0-1.15-0.94-2.09-2.09-2.09H7.25c-1.15,0-2.09,0.94-2.09,2.09v1.7H2.02h-1.1 c-0.42,0,1.1,0,1.1,0v20.23c0,2.3,1.87,4.17,4.17,4.17h14.6c2.3,0,4.17-1.87,4.17-4.17V4.69C24.98,4.69,26.5,4.69,26.08,4.69z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 8.98,
    y1: 25.39,
    x2: 8.98,
    y2: 12.05
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 13.55,
    y1: 25.39,
    x2: 13.55,
    y2: 12.05
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 18.02,
    y1: 12.05,
    x2: 18.02,
    y2: 25.39
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 21.99,
    y1: 9.36,
    x2: 5.12,
    y2: 9.36
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconDelete, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_delete.d85a28d2.svg";
export { ForwardRef as ReactComponent };